import CardProducer from '~/components/Molecules/CardProducer/CardProducer.vue'

export default {
  props: {
    propBus: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      cardProducer: CardProducer,
      swiperOptions: {
        spaceBetween: 24,
        speed: 7000,
        allowTouchMove: false,
        centeredSlides: true,
        loop: true,
        loopedSlides: 4,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          768: {
            slidesPerView: 2.5,
          },
          375: {
            slidesPerView: 1.5,
          },
          320: {
            slidesPerView: 1.2,
          },
        },
      },
    }
  },
}
